<template>
  <TipBox info no-border :title="$t('tips.externalId.title')" v-if="ready && isVeloce">
    <span v-html="$t('tips.externalId.description')"></span>
  </TipBox>
</template>

<script>
export default {
  name: "TipsExternalId",

  data() {
    return {
      company: null,
      ready: false
    }
  },

  computed: {
    isVeloce() {
      return this.company && this.company.activePOS && this.company.activePOS[0] === "veloce";
    },
  },

  async mounted() {
    this.company = await this.$store.getters.getContextCompany;
    this.ready = true;
  }
}
</script>